var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmailFreeTrial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2626C0 10.6713 0.632141 9.14515 1.75736 8.01993C2.88258 6.89471 4.4087 6.26257 6 6.26257H54C55.5913 6.26257 57.1174 6.89471 58.2426 8.01993C59.3679 9.14515 60 10.6713 60 12.2626V48.2626C60 49.8539 59.3679 51.38 58.2426 52.5052C57.1174 53.6304 55.5913 54.2626 54 54.2626H6C4.4087 54.2626 2.88258 53.6304 1.75736 52.5052C0.632141 51.38 0 49.8539 0 48.2626V12.2626ZM10.557 12.2626L30 29.2756L49.443 12.2626H10.557ZM54 16.2496L31.977 35.5216C31.4299 36.0009 30.7274 36.2651 30 36.2651C29.2726 36.2651 28.5701 36.0009 28.023 35.5216L6 16.2496V48.2626H54V16.2496Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8728 44H51.7702C51.9849 43.3212 52.0504 42.5949 51.9614 41.882C51.8724 41.1691 51.6314 40.4904 51.2586 39.9028C50.8858 39.3151 50.392 38.8357 49.8187 38.5046C49.2454 38.1735 48.6092 38.0005 47.9636 38H44V40.9992H48.8728V44Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43.5007H44.1282V41H41.2327C41.0164 41.5656 40.9496 42.1711 41.0378 42.7657C41.126 43.3603 41.3666 43.9265 41.7396 44.4166C42.1125 44.9067 42.6067 45.3064 43.1806 45.5819C43.7544 45.8575 44.3912 46.0009 45.0372 46H49V43.5007Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailFreeTrial);
export default __webpack_public_path__ + "static/media/icon-email-free-trial.8d494569f2ef031df5e34e6ebecbbb44.svg";
export { ForwardRef as ReactComponent };